import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';

const _GetFacilityExpensesRequestDtoSchema = z.object({
  facilityId: z.number(),
  from: z.string().refine((val) => !isNaN(Date.parse(val)), 'Invalid datetime'),
  to: z.string().refine((val) => !isNaN(Date.parse(val)), 'Invalid datetime'),
});

const GetFacilityExpensesResponseDtoSchema = z.object({
  amount: z.number().nullable(),
  changePct: z.number().nullable(),
  insufficientData: z.boolean().optional(),
  message: z.string().nullable().optional(),
});

export type GetFacilityExpensesRequestDto = z.infer<
  typeof _GetFacilityExpensesRequestDtoSchema
>;
export type GetFacilityExpensesResponseDto = z.infer<
  typeof GetFacilityExpensesResponseDtoSchema
>;

export const getFacilityExpenses = (
  params: GetFacilityExpensesRequestDto,
  config?: AxiosRequestConfig<GetFacilityExpensesRequestDto>
) => {
  const { facilityId, ...restParams } = params;

  return api
    .get(`/facilities/${facilityId}/expenses`, {
      params: restParams,
      ...config,
    })
    .then(responseContract(GetFacilityExpensesResponseDtoSchema));
};
